
import { ModalHandler } from '../mixins/ModalHandler'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter } from 'vuex-class'
import { Mixins, Component } from 'vue-property-decorator'
import Button from 'umg-components/src/components/atoms/Button.vue'
import Headline from 'umg-components/src/components/atoms/Headline.vue'
import Paragraph from 'umg-components/src/components/atoms/Paragraph.vue'
import Icon from 'umg-components/src/components/atoms/Icon.vue'
import Modal from 'umg-components/src/components/molecules/Modal.vue'
import Card from 'umg-components/src/components/molecules/Card.vue'
import AssetServiceLogin from './AssetServiceLogin.vue'

@Component({
  components: {
    AssetServiceLogin,
    Button,
    Modal,
    Paragraph,
    Headline,
    Icon,
    Card,
  },
})
export default class FaqModal extends Mixins(TranslationHandler, ModalHandler) {
  @Getter visualPrimaryColor!: string
  @Getter visualIsDark!: boolean
  @Getter visualTextColor!: string
  @Getter visualFont!: string
  @Getter visualButtonTextColor!: string

  @Getter translationFaqs!: { title: string, text: string, image: string }[]
  @Getter translationFaqLocations!: { page: string, service: string }[]

  @Getter userService!: string

  isAccordionOpenMap: { [key: string]: boolean } = {}

  get faqs(): { title: string, text: string, image: string }[] {
    return this.translationFaqs
      .filter((_, index) => {
        let isShown: boolean = true

        if (!this.translationFaqLocations[index]) { // legacy, if the location doesn't exist always show
          return isShown
        }

        const { page, service } = this.translationFaqLocations[index]

        if (page !== 'All') { // page all, no filter
          isShown = page === this.$route.name
        }

        if (isShown === true && service !== 'All') { // service all, no filter
          isShown = service.toLowerCase() === this.userService.toLowerCase()
        }

        return isShown
      })
  }

  get translations() {
    return {
      title: this.$t('faqTitle'),
      buttonClose: this.$t('faqClose'),
    }
  }

  get background(): string {
    return this.visualIsDark ? '#141418' : '#F5F5FF'
  }

  toggleAccordion(index: number) {
    if (this.isAccordionOpenMap[index] !== undefined) {
      this.isAccordionOpenMap[index] = !this.isAccordionOpenMap[index]

      return
    }

    this.$set(this.isAccordionOpenMap, index, true)
  }
}
